import { ReactNode } from "react"

// ** Custom Components
import Footer from "../Footer"
import NavigationMenu from "../NavigationMenu"

// ** Custom Styling
import "./layout.css"
import SingleKeyFooter from "../SingleKeyFooter"

interface LayoutProps {
  children: ReactNode
  lang?: string
  partnerLogo?: string
  pageContext?: any
}

function Layout(props: LayoutProps) {
  const { children, partnerLogo, pageContext } = props

  return (
    <>
      {/* Header */}
      <NavigationMenu partnerLogo={partnerLogo} pageContext={pageContext} />
      {children}
      {/* Footer */}
      {pageContext?.singleKey || pageContext?.exprior ? (
        <SingleKeyFooter
          lang={"en_US"}
          lrp={true}
          exprior={pageContext?.exprior}
        />
      ) : (
        <Footer />
      )}
    </>
  )
}

export default Layout
